import { render, staticRenderFns } from "./TagSidebar.vue?vue&type=template&id=06188a58&"
import script from "./TagSidebar.vue?vue&type=script&lang=js&"
export * from "./TagSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports